import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { ReactNode, useState } from 'react';

import BPImage from '../../ui/v2/image';
import BPModal from '../../ui/modal';

const ExtraInfo = ({
  title,
  content,
}: {
  title?: string;
  content: ReactNode;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <span>
      <button
        className={cx(
          'cursor-pointer',
          'inline-block',
          'align-middle',
          'focus:outline-none',
          '-mb-1',
          'ml-1'
        )}
        onClick={() => setShowModal(true)}
      >
        <BPImage
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/info_icon.svg`}
          width={16}
          height={16}
          layout="fixed"
        />
      </button>
      {showModal && (
        <BPModal
          variant="alert"
          isOpen={true}
          onRequestClose={() => setShowModal(false)}
          title={title || t('common:extra-info')}
          titleVariant="left"
        >
          {content}
        </BPModal>
      )}
    </span>
  );
};

export default ExtraInfo;
